import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MyTalentRateComponent} from './my-talent-rate.component';
import {IwgcommonModule} from '../iwgcommon/iwgcommon.module';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {MaterialModule} from '../shared/material/material.module';
import {FlexLayoutModule} from '@angular/flex-layout';
import {SharedPipesModule} from '../shared/pipes/sharedpipes.module';



@NgModule({
  declarations: [MyTalentRateComponent],
  imports: [
    CommonModule,
    IwgcommonModule,
    FormsModule,
    RouterModule,
    MaterialModule,
    FlexLayoutModule,
    SharedPipesModule
  ],
  exports: [MyTalentRateComponent]
})
export class MyTalentRateModule { }
